import "slick-carousel";

const handleSlider = (element) => {
  let $slider = element;

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    draggable: false,
  });
};

export default handleSlider;
